import { useState, useEffect } from 'react';
import { getUserProfile, type UserProfile } from '@/lib/admin';
import { hasPremiumAccess } from '@/lib/stripe';

export function usePremiumAccess(userId: string | undefined) {
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState<UserProfile | null>(null);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    getUserProfile(userId).then((p) => {
      if (cancelled) return;
      setProfile(p);
      setIsPremium(
        hasPremiumAccess({
          hasPurchased: p?.hasPurchased,
          subscriptionStatus: p?.subscriptionStatus,
          subscriptionCurrentPeriodEnd: p?.subscriptionCurrentPeriodEnd,
        })
      );
      setLoading(false);
    });

    return () => { cancelled = true; };
  }, [userId]);

  return { isPremium, loading, profile };
}
